import { Loading } from 'element-ui';
 
let loadingCount = 0;
let loading;
 
// WARNING:
// `startLoading`与`showLoading`不能用箭头函数，要用普通函数，
// 因为要用 vue-i18n 就得获取 vue实例 上挂载的 `$t()`
const startLoading = function() {
	// console.log('showLoading =>', this)
	// console.log('showLoading =>', this.$t)
	// console.log('showLoading =>', this.$t('common.loading2'))
	let text = '请稍候...'
	if(this && this.$t) {
		text = this.$t('common.loading2')
	}
	// console.log('请稍候... =>', text)
  loading = Loading.service({
    lock: true,
    text: text,//可以自定义文字
    spinner:'el-icon-loading',//自定义加载图标类名
    background: 'rgba(255, 255, 255, 0.618)'//遮罩层背景色
  });
};
 
const endLoading = () => {
	setTimeout(() => {
		loading.close();
	})
};

export const showLoading = function() {
  if (loadingCount === 0) {
    startLoading.call(this);
  }
  loadingCount += 1;
};
 
export const hideLoading = () => {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
};


// WEBPACK FOOTER //
// ./src/assets/loading.js